import { DefaultSeoProps } from "next-seo";

// eslint-disable-next-line prefer-destructuring
const NEXT_PUBLIC_VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV;

const sitePath =
    NEXT_PUBLIC_VERCEL_ENV === "production"
        ? "https://carl-topham.com"
        : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}` || "http://localhost:3000";
const ogImageUrl = `${sitePath}/images/og-image.png`;

const config: DefaultSeoProps = {
    openGraph: {
        type: "website",
        locale: "en",
        url: "https://carl-topham.com",
        siteName: "Carl Topham - JavaScript & React Engineer",
        images: [
            {
                url: ogImageUrl,
                width: 1200,
                alt: "Carl Topham - JavaScript & React Engineer"
            }
        ]
    },
    twitter: {
        handle: "@Designer023",
        site: "@site",
        cardType: "summary_large_image"
    }
};

export default config;
